export const VISIBILITY_SCOPE_NONE = 'VISIBILITY_SCOPE_NONE';
export const COOKIE_BAR_VISIBILITY_SCOPE = 'COOKIE_BAR_VISIBILITY_SCOPE';
export const COOKIE_MODAL_VISIBILITY_SCOPE = 'COOKIE_MODAL_VISIBILITY_SCOPE';
export const NOTIFICATION_VISIBILITY_SCOPE = 'NOTIFICATION_VISIBILITY_SCOPE';

export const TAB_SCOPE_PREFERENCES = 'legal_cookie_preferences';
export const TAB_SCOPE_PRIVACY = 'legal_privacy_policy';
export const TAB_SCOPE_CONTACT = 'legal_contact';
export const COOKIE_MODAL_VISIBILITY_SCOPE_DETAIL = 'COOKIE_MODAL_VISIBILITY_SCOPE_DETAIL';



// WEBPACK FOOTER //
// ./vendor/kunstmaan/cookie-bundle/Resources/ui/js/state/state.config.js